import { Typography } from "@mui/material";
import React, { ReactNode } from "react";

// The line under a page heading: 15px, muted, left-aligned with it.
const DescriptionText = ({ children }: { children: ReactNode }) => {
  return (
    <Typography sx={{ fontSize: 15, lineHeight: 1.5, color: "text.secondary" }}>
      {children}
    </Typography>
  );
};

export default DescriptionText;
